import React from 'react';
import Login from '../components/page-components/login/Login';

const LoginPage = (): JSX.Element => {
  return <Login />;
};

export default LoginPage;
